import type { components as AccountlessApiComponents } from './generated/accountless-natalie-api';
import type { components as NatalieApiComponents } from './generated/natalie-api';
import type { PaginatedApiParamsV3 } from 'domain/Common';

// Re-export the generated enum type as a const enum for runtime use
export const NatalieEventStatus = {
  Active: 'ACTIVE',
  Completed: 'COMPLETED',
} as const;

export type NatalieEventStatus = NatalieApiComponents['schemas']['NatalieEventStatus'];

// --- API response types (generated from OpenAPI spec) ---

/** Full event DTO returned by natalie-api */
export type NatalieEventDto = NatalieApiComponents['schemas']['NatalieEventDto'];

/** Create/update request body */
export type NatalieEventCreateDto = NatalieApiComponents['schemas']['NatalieEventCreateDto'];

/** LiveKit token response */
export type GetLiveKitTokenData = NatalieApiComponents['schemas']['TokenResponse'];

/** Accountless event info response */
export type AccountlessNatalieEventApiResponse = AccountlessApiComponents['schemas']['EventInfoResponse'];

// --- Frontend query param types ---

export type GetNatalieEventListApiParams = PaginatedApiParamsV3 & {
  communityId: number;
  statuses: NatalieEventStatus[];
};

/** Alias used by list views — same shape as the API DTO */
export type NatalieEventListItem = NatalieEventDto;

// --- Frontend-derived detail types (mapped from API DTO) ---

/** Input type for the public-event mapper (API response shape) */
export type NatalieEventPublicDetailData = NatalieEventDto;

/** Input type for the authenticated-event mapper (API response shape) */
export type NatalieEventDetailData = NatalieEventDto;

/** Mapped public event detail used by UI components */
export type NatalieEventPublicDetail = {
  id: string;
  communityId: string;
  endDate: string;
  name: string;
  description: string | null;
  topic: string;
  ownerName: string;
  communityName: string;
  status: NatalieEventStatus;
  communityLogo: string | null;
  videoUrl: string | null;
  durationInMinutes: number;
  /**
   * 12-char test-link invite code. Lets the Guest landing recognise a test link
   * (its URL invite-code position is shared by the real and test code). Null when
   * the event has no test link or the (accountless) endpoint does not expose it.
   */
  testInviteCode: string | null;
};

/** Mapped authenticated event detail used by UI components */
export type NatalieEventDetail = NatalieEventPublicDetail;

// --- Frontend-only types (not in OpenAPI spec) ---

export type CreateNatalieEventApiParams = {
  communityId: number;
  name: string;
  description?: string | null;
  topic: string;
  sessionDurationMinutes: number;
  endDate: string;
  status: NatalieEventStatus;
  videoUrl?: string;
};

export type UpdateNatalieEventApiParams = CreateNatalieEventApiParams & {
  id: string;
};

export type RegisterToNatalieEventArgs = {
  id: string;
  /**
   * When true, suppresses navigation to join page and MemberSetup dialog.
   * Used for magic link auth flow where the user is auto-registered silently.
   */
  silent?: boolean;
};

// LiveKit token query params (frontend-specific, includes debug/agentName)
export type GetLiveKitTokenParams = {
  eventId: string;
  version?: string;
  slot?: string;
  mode?: 'voice' | 'text';
  agentName?: string;
  debug?: boolean;
  /**
   * 12-char test-link invite code from the Registered test Room URL. When
   * present the server resolves source=test and returns `isTest=true`; the
   * client never asserts test-ness itself.
   */
  testInviteCode?: string;
};

// Accountless token params for POST /natalie/{eventId}/token/{inviteCode}
export type GetAccountlessLiveKitTokenParams = {
  eventId: string;
  inviteCode: string;
};

/** Body schema for POST /natalie/{eventId}/{inviteCode}/reminder */
export type ScheduleAccountlessReminderBody = AccountlessApiComponents['schemas']['ScheduleReminderRequest'];

export type ScheduleAccountlessReminderArgs = ScheduleAccountlessReminderBody & {
  eventId: string;
  inviteCode: string;
};
